import { ITsNganhXetTuyenReducer } from "./../../reducer-model/category/ITsNganhXetTuyenReducer";
import { ITsNganhXetTuyenActionTypes } from "../../action-types/category/ITsNganhXetTuyenActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: ITsNganhXetTuyenReducer = {
  status: eReducerStatusBase.is_not_initialization,
  tsNganhXetTuyens: [],
};
export const tsNganhXetTuyenReducer = (
  state: ITsNganhXetTuyenReducer = iniState,
  action: ITsNganhXetTuyenActionTypes
): ITsNganhXetTuyenReducer => {
  switch (action.type) {
    case "NGANH_XET_TUYEN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "NGANH_XET_TUYEN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        tsNganhXetTuyens: action.payload,
      };
    case "NGANH_XET_TUYEN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
